import { FC } from 'react';

import BreakdownTooltip from '@/components/BreakdownTooltip';
import { Td } from '@/components/Table';
import {
  submissionTotalAmount,
  submissionTotalBonus,
} from '@/pages/GenerateInvoice/invoiceTotals';
import { FreelancerInvoiceSubmissionResource } from '@/types/resources';
import { formatInvoiceAmount, renderCurrencyCodeSign } from '@/utils/helpers';

import {
  amountBreakdownItems,
  bonusBreakdownItems,
} from './invoiceBreakdownItems';

interface Props {
  submission: FreelancerInvoiceSubmissionResource;
}

/** Amount / Bonus / VAT / Total cells — everything money-related in one row. */
const InvoiceAmountCells: FC<Props> = ({ submission }) => {
  const { currency, amounts, bonuses } = submission;

  const totalAmount = submissionTotalAmount(submission);
  const totalBonus = submissionTotalBonus(submission);
  const vat = Number(submission.vat ?? 0);
  const total = parseFloat((totalAmount + totalBonus + vat).toFixed(2));

  const sign = renderCurrencyCodeSign(currency);
  const amount = formatInvoiceAmount(totalAmount, currency);
  const bonus = formatInvoiceAmount(totalBonus, currency);

  return (
    <>
      <Td>
        {amounts && amounts.length > 1 ? (
          <BreakdownTooltip
            title="Amount details"
            items={amountBreakdownItems(amounts, currency)}
            total={amount}
          >
            {amount}
          </BreakdownTooltip>
        ) : (
          amount
        )}
      </Td>
      <Td>
        {bonuses && bonuses.length > 1 ? (
          <BreakdownTooltip
            title="Bonus details"
            items={bonusBreakdownItems(bonuses, currency)}
            total={bonus}
          >
            {bonus}
          </BreakdownTooltip>
        ) : totalBonus > 0 ? (
          bonus
        ) : (
          '-'
        )}
      </Td>
      <Td>
        {sign}
        {vat.toFixed(2)}
      </Td>
      <Td>
        {sign}
        {total.toFixed(2)}
      </Td>
    </>
  );
};

export default InvoiceAmountCells;
